import { memo } from "react";
import { DialogModal, IconButton } from "veronica-ui-component/dist/component/core";
import UpdateChargeVesselContent from "./UpdateChargeVesselContent";
import { useChargeDetailVM } from "presentation/hook/ChargeDetailMaintenance/useChargeDetailVM";
import { ChargeDetailConstant } from "presentation/constant/ChargeDetailMaintenance/ChargeDetailConstant";
import { ChargeDetailModel } from "presentation/model/ChargeDetailMaintenance/ChargeDetailModel";

const UpdateChargeVesselComp = ({ chargeDetailState, updateStatusType }:
    { chargeDetailState: ChargeDetailModel, updateStatusType: string }) => {
    const chargeDetailVM = useChargeDetailVM();
    const { isShowFindVesselPanel } = chargeDetailState;

    const handleCloseDialog = () => {
        chargeDetailVM.closeVesselPanel();
    }
    return <DialogModal style={{ minWidth: '62vw', minHeight: '82vh' }}
        appendTo='self'
        showButton={false}
        visible={isShowFindVesselPanel}
        positions="center"
        resizable={false}
        header={
            <div className="im-charge-data-search-confirm-modal-header">
                <span className="name">{ChargeDetailConstant.Vessel.CO_VSL_VOY_TITLE}</span>
                <IconButton fileName='Icon-cross' size="medium" onClick={handleCloseDialog} tooltipDisable={true} />
            </div>
        }
        dialogContent={<UpdateChargeVesselContent chargeDetailState={chargeDetailState} updateStatusType={updateStatusType} />}
        className="im-charge-data-search-confirm-modal"
    />
}

export default memo(UpdateChargeVesselComp);